import { GlIcon, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
export default {
    name: 'ProjectVisibilityIcon',
    i18n: {
        privateProjectTooltip: s__('CiCatalog|Private - This component project can only be viewed by project members.')
    },
    components: {
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    }
};
